(() => {
  angular.module('app').component('clinicPatientTicketTreatment', {
    templateUrl: require('./widget.html'),
    controller: ClinicPatientTicketTreatmentController,
    controllerAs: 'vm',
    bindings: {
      isDisabled: '<',
      isExpanded: '<',
      isCompleted: '<',
      onDirtyEvent: '<',
      onSetPristineEvent: '<',
      quantity: '<',
      strength: '<',
      dosage: '<',
      treatmentType: '<',
      treatments: '<',
      ticket: '<',
      pharmacy: '<',
      corporateId: '<',
      onSyncExpansion: '&',
      onValidateTreatment: '&',
      onComplete: '&',
      isCreate: '<',
      currencyCode: '<',
      countryCode: '<',
      isApplyTax: '<',
      taxDescription: '<',
    }
  });

  ClinicPatientTicketTreatmentController.$inject = [
    '$filter', 
    'abp.services.app.drugSearch', 
    'Hms.PatientTickets.TreatmentType'
  ];

  function ClinicPatientTicketTreatmentController(
    $filter, drugSearchSvc, enumPatientTicketTreatmentType) {
    
    const unitValueFilter = $filter('unitValue');
    const vm = this;

    vm.enums = {};
    vm.enums.patientTicketTreatmentTypes = enumPatientTicketTreatmentType;

    vm.hasGPTicketEnhancement = abp.setting.getBoolean(
      'Hms.Feature.GPTicketEnhancement'
    );

    vm.totalGrossAmount = 0;
    vm.totalTaxAmount = 0;
    vm.totalTreatmentAmount = 0;

    vm.$onChanges = $onChanges;
    vm.$doCheck = $doCheck;
    vm.onDirtyEventHandler = onDirtyEventHandler;
    vm.onSetPristineEventHandler = onSetPristineEventHandler;
    vm.next = next;
    vm.areFieldsValid = areFieldsValid;
    vm.hasTreatment = hasTreatment;
    vm.checkDuplicateTreatment = checkDuplicateTreatment;
    vm.updateTreatment = updateTreatment;
    vm.tidyTreatmentPrescriptions = tidyTreatmentPrescriptions;
    vm.updatePrescription = updatePrescription;
    vm.lookupDrugs = lookupDrugs;
    vm.onTreatmentTypeChange = onTreatmentTypeChange;

    vm.checkExclusionsForPrescription = checkExclusionsForPrescription;

    vm.hasDrugEnhancement = abp.setting.getBoolean('Hms.Feature.DrugEnhancement');

    function $onChanges(changes) {
      vm.newTreatments = _.filter(vm.treatments, (t) => t.displayName !== 'Consultation');

      tidyTreatments();

      // Localize the treatment types.

      if (vm.ticket && vm.ticket.treatments) {
        _.each(vm.ticket.treatments, t => {
          if (t.prescriptions) {
            _.each(t.prescriptions, p => {
              p.treatmentType =
                p.treatmentType !== null &&
                p.treatmentType !== '' &&
                p.treatmentType !== undefined
                  ? Number(p.treatmentType)
                  : null;
            });
          }
        });
      }

      if (changes.isExpanded) {
        vm.isOpen = vm.isExpanded;
        updatePostHeader();
      }

      if (changes.onDirtyEvent && changes.onDirtyEvent.currentValue) {
        vm.onDirtyEvent.handler = vm.onDirtyEventHandler;
      }

      if (changes.onSetPristineEvent && changes.onSetPristineEvent.currentValue) {
        vm.onSetPristineEvent.handler = vm.onSetPristineEventHandler;
      }
    };

    function $doCheck() {
      if (vm.isOpen !== vm.isOpenPreviousValue) {
        // Component expansion must stay in sync with the parent isExpanded state.
        // uib-accordion toggles isOpen by itself when user clicks on it.

        vm.onSyncExpansion({ isExpanded: vm.isOpen });
        vm.isOpenPreviousValue = vm.isOpen;
      }
    };

    vm.isOpen = false;
    vm.isOpenPreviousValue = false;
    vm.summaryMessage = '';
    vm.treatmentsIsValid = false;
    vm.filteredDrugs = [];
    let isOnNext = false;

    function onDirtyEventHandler() {
      return vm.treatmentForm.$dirty;
    };

    function onSetPristineEventHandler() {
      vm.treatmentForm.$setPristine();
    };

    // To retrieve drug listing including the manual entry (drug suggestion) added by clinic user.

    function next() {
      if (App.isFormValid(vm.treatmentForm) && vm.areFieldsValid()) {
        _.each(vm.ticket.treatments, (t) => {
          t.amount = 0;
          _.each(t.prescriptions, (p) => {
            if (t.treatment && p.amount) {
              t.amount += p.amount;
            }
          });
        });

        vm.onComplete();
      } else {
        isOnNext = true;
      }
    };

    function areFieldsValid() {
      // Allow next when patient has pharmacy benefit and there is no treatment.

      if (vm.pharmacy && !vm.hasTreatment()) return true;

      let isValid = true;
      const isTreatmentValid = vm.onValidateTreatment();

      if (!vm.ticket.consultation && !isTreatmentValid) isValid = false;

      return isValid;
    };

    function hasTreatment() {
      return _.some(vm.ticket.treatments, (t) => t.treatmentId || t.amount);
    };

    function checkDuplicateTreatment(treatment) {
      return _.some(vm.ticket.treatments, { 'treatmentId': treatment.id });
    };

    function updateTreatment(ticketTreatment) {
      // Validate whether treatment is covered.

      if (ticketTreatment.treatmentId) {
        const treatment = _.find(vm.treatments, { 'id': ticketTreatment.treatmentId });
        ticketTreatment.isUncovered = treatment.notCovered;
      }

      tidyTreatments();
    };

    function calculateAmounts(prescriptions) {
      const taxRate = ((vm.ticket.taxPercentage || 0) / 100) + 1;

      _.each(prescriptions, (x) => {
        if (x.amount == null) {
          x.grossAmount = null;
          x.taxAmount = null;
        } else if (x.amount > 0) {
          if (vm.isApplyTax) {
            // Apply tax for foreigners
            x.grossAmount = App.evenRound(x.amount/taxRate, 2);
            x.taxAmount = App.evenRound(x.amount - x.grossAmount, 2);
          } else {
            // No tax for locals
            x.grossAmount = App.evenRound(x.amount, 2);
            x.taxAmount = App.evenRound(0, 2);
          }
        } else {
          x.grossAmount = 0;
          x.taxAmount = 0;
        }
      });

      calculateTotalAmount();
    }

    function calculateTotalAmount() {
      vm.totalGrossAmount = 0;
      vm.totalTaxAmount = 0;
      vm.totalTreatmentAmount = 0;

      _.each(vm.ticket.treatments, (t) => {
        if (t.treatmentId) {
          _.each(t.prescriptions, (p) => {
            vm.totalGrossAmount += (p.grossAmount || 0);
            vm.totalTaxAmount += (p.taxAmount || 0);
            vm.totalTreatmentAmount += (p.amount || 0);
          });
        }
      });
    }

    const priceRangeMargin = parseFloat(abp.setting.get('Hms.General.GpAveragePriceRangeMargin'));

    function tidyTreatmentPrescriptions(treatment) {

      calculateAmounts(treatment.prescriptions);
      // Initialise prescriptions array if necessary.

      if (!treatment.prescriptions) treatment.prescriptions = [];

      // Set drug id to less than -1 for new drug (drug suggestion).

      let prescriptionCnt = -1;
      treatment.amount = 0;
      _.forEach(treatment.prescriptions, (p) => {
        if (p.drugId === null && p.name) {
          prescriptionCnt -= 1;
          p.drugId = prescriptionCnt;
        }

        // Calculate treatment amount.

        if (treatment.treatment && p.amount) {
          treatment.amount += p.amount;
        }
      });

      // Calculate prescription.

      let filledCnt = 0;
      let blankCnt = 0;
      _.each(treatment.prescriptions, (p) => {
        if (p.drugId) filledCnt += 1;
        else blankCnt += 1;
      });
      treatment.prescriptionCount = filledCnt;

      // Remove superfluos empty prescriptions.

      while (blankCnt > 1) {
        for (let i = treatment.prescriptions.length - 1; i >= 0; i -= 1) {
          if (!treatment.prescriptions[i].drugId) {
            treatment.prescriptions.splice(i, 1);
            blankCnt -= 1;
          }
        }
      }

      // Ensure there is always a blank prescription line.

      if (blankCnt < 1) treatment.prescriptions.push({});

      // Update treatment error and alert message.

      let errorMessage = '';
      const alertMessages = [];
      if (treatment.treatmentId) {
        _.some(vm.ticket.treatments, (t) => {
          if (t === treatment) return false;
          if (t.treatmentId === treatment.treatmentId) {
            errorMessage = App.localize('DuplicateTreatmentValidationErrorMessage');
            return true;
          }
          return false;
        });

        if (!errorMessage && !filledCnt && isOnNext) {
          errorMessage = App.localize('KeyInOnePrescriptionProcedure');
        }

        if (!errorMessage && filledCnt) {
          _.forEach(treatment.prescriptions, (p) => {
            if (!p.drugId) return;

            // Always show overcharge prescription 
            // if prescription amount more than average prescription amount.

            p.isExceedAveragePrice = false;
            if (p.quantity
              && p.drugId > 0
              && p.pricePerUnit
              && p.amount > 0
              && p.preferredQuantityUnit === p.quantity.unit
              && vm.countryCode === 'MY') {
              const averageTotalAmount = p.pricePerUnit * p.quantity.value;

              // Calculate price range based on ±margin of price per unit.
              // Round up to 1 decimal point only.

              const minAmount = Math.round(averageTotalAmount * (1 - priceRangeMargin) * 10) / 10;
              const maxAmount = Math.round(averageTotalAmount * (1 + priceRangeMargin) * 10) / 10;

              if (p.amount > maxAmount) {
                p.isExceedAveragePrice = true;
                alertMessages.push(
                  App.localize('OverchargePrescriptionForXOfY',
                    p.quantity.text,
                    p.name,
                    $filter('currencyFormat')(minAmount, vm.currencyCode),
                    $filter('currencyFormat')(maxAmount, vm.currencyCode))
                );
              }
            }

            if (!errorMessage && !p.quantity && isOnNext) {
              errorMessage = App.localize('MissingQuantityForX', p.name);
            }

            if (
              !errorMessage
              && (p.amount === null
                || !Number.isFinite(p.amount)
                || p.amount < 0)
              && isOnNext) {
              errorMessage = App.localize('MissingOrInvalidAmountForX', p.name);
            }
          });
        }
      } else if (!vm.ticket.consultation) {
        const isHasTreatment = _.some(vm.ticket.treatments, 'treatmentId');
        if (!isHasTreatment) errorMessage = App.localize('EmptyTreatmentValidationErrorMessage');
      }
      treatment.errorMessage = errorMessage;
      treatment.alertMessages = alertMessages;
    };

    vm.treatmentCount = 0;

    function tidyTreatments() {
      // Check that ticket is defined.

      if (!vm.ticket) return;

      // Initialise treatment array if necessary.

      if (!vm.ticket.treatments) vm.ticket.treatments = [];

      let filledCnt = 0;
      let blankCnt = 0;
      _.forEach(vm.ticket.treatments, (t) => {
        // Calculate blank treatments.

        if (t.treatmentId) filledCnt += 1;
        else blankCnt += 1;

        // Create treatment object.

        t.treatment = _.find(vm.treatments, ['id', t.treatmentId]);
      });
      vm.treatmentCount = filledCnt;

      // Remove superfluos empty treatments.

      while (blankCnt > 1) {
        for (let i = vm.ticket.treatments.length - 1; i >= 0; i -= 1) {
          if (!(+vm.ticket.treatments[i].treatmentId)) {
            vm.ticket.treatments.splice(i, 1);
            blankCnt -= 1;
          }
        }
      }

      // Ensure there is always a blank treatment line.

      if (blankCnt < 1) vm.ticket.treatments.push({});

      // For each treatment, tidy their prescriptions.

      _.forEach(vm.ticket.treatments, (t) => {
        vm.tidyTreatmentPrescriptions(t);
      });
    }

    function updatePrescription(prescription) {
      if (prescription.drugId) {
        const selectedDrug = _.find(vm.filteredDrugs, { id: prescription.drugId });
        if (selectedDrug) {
          if (
            selectedDrug.strength !== null
            && Number.isFinite(selectedDrug.strength)
            && selectedDrug.strengthUnit) {
            prescription.strength = {
              value: selectedDrug.strength,
              unit: selectedDrug.strengthUnit
            };
            prescription.strength.text = unitValueFilter(prescription.strength);
          } else {
            prescription.strength = null;
          }

          if (prescription.drugId < 0 && selectedDrug.id < 0) {
            // Set new drug id to negative number of current time.
            // To resolve ng-change where unable to change new drug,
            // due to drug listing set to -1 for all new drug (drug suggestion).

            const newId = new Date().getTime();
            prescription.drugId = -Math.abs(newId);
          }

          prescription.preferredQuantityUnit = selectedDrug.quantityUnit || '';
          prescription.preferredDosageUnit = selectedDrug.dosageUnit || '';
          prescription.name = selectedDrug.productName;
          prescription.pricePerUnit = selectedDrug.pricePerUnit;
        }
      } else {
        prescription.name = null;
      }
      tidyTreatments();
    };

    let lastFilter = '';
    const cachedResults = {};

    function cleanUserEntry(entry) {
      return _.map(_.split(_.toLower(entry), ' '), (word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    function searchDrugs(userEntry, prescription) {
      const cleanedUserEntry = cleanUserEntry(userEntry || '');
      const filter = _.toLower(cleanedUserEntry);
      lastFilter = filter;

      if (filter) {
        const cachedDrugs = cachedResults[filter];

        if (cachedDrugs) {
          if (
            prescription.treatmentType != vm.enums.patientTicketTreatmentTypes.Medications.id &&
            vm.countryCode === 'MY' && vm.hasDrugEnhancement
          ) {
            vm.filteredDrugs = postProcessDrugList([], filter, cleanedUserEntry);
          } else {
            vm.filteredDrugs = postProcessDrugList(cachedDrugs, filter, cleanedUserEntry);
          }
        } else {
          if (vm.hasDrugEnhancement && vm.countryCode === 'MY') {
            drugSearchSvc
              .searchDrugMedicines({
                keyword: filter,
                countryCode: vm.countryCode,
                treatmentType: prescription.treatmentType,
              })
              .success((d) => {
                cachedResults[filter] = d.items;
                if (filter === lastFilter) {
                  vm.filteredDrugs = postProcessDrugList(d.items, filter, cleanedUserEntry);
                }
              });
          } else {
            drugSearchSvc
              .searchDrugs({
                keyword: filter,
                countryCode: vm.countryCode,
              })
              .success((d) => {
                cachedResults[filter] = d.items;
                if (filter === lastFilter) {
                  vm.filteredDrugs = postProcessDrugList(d.items, filter, cleanedUserEntry);
                }
              });
          }
        }
      } else {
        vm.filteredDrugs = [];
      }

      function postProcessDrugList(drugList, filterText, cleanedEntry) {
        const clonedItems = drugList.slice(0);
        const idx = _.findIndex(
          clonedItems,
          (d) => _.toLower(_.trim(d.productName || '')) === filterText
        );
        if (idx > 0) {
          const items = clonedItems.splice(idx, 1);
          clonedItems.splice(0, 0, items[0]);
        } else if (idx === -1) {
          clonedItems.splice(0, 0, {
            id: -1,
            productName: cleanedEntry,
          });
        }
        // When drug enhancement is enabled, sync drugId to snowflakeId
       if (vm.hasDrugEnhancement && vm.countryCode === 'MY') {
          _.each(clonedItems, (drug) => {
            if (drug.snowflakeId !== undefined && drug.snowflakeId !== null) {
              drug.id = drug.snowflakeId;
            }
          });
        }

        return clonedItems;
      }
    }

    function lookupDrugs(filter, prescription) {
      searchDrugs(filter, prescription);
    };

    // Ensure correct treatment type is displayed on selection.

    function onTreatmentTypeChange(prescription) {
      if (prescription.treatmentType != null) {
        prescription.treatmentType = Number(prescription.treatmentType);
      }
    };    

    function updatePostHeader() {
      // Calculate number of treatments, prescriptions, and uncovered treatments

      let treatmentCount = 0;
      let prescriptionCount = 0;
      let uncoveredTreatmentCount = 0;

      _.forEach(vm.ticket.treatments, (t) => {
        if (!t.treatmentId) return;

        treatmentCount += 1;

        const treatment = _.find(vm.newTreatments, { 'id': t.treatmentId });
        if (treatment.notCovered) uncoveredTreatmentCount += 1;

        _.forEach(t.prescriptions, (p) => {
          if (p.drugId) prescriptionCount += 1;
        });
      });

      // Construct header message.

      const message = [];
      if (prescriptionCount) {
        if (uncoveredTreatmentCount) {
          message.push(App.localize('TreatmentWithUncoveredAndPrescriptionSummaryNarrative',
            treatmentCount, uncoveredTreatmentCount, prescriptionCount));
        } else {
          message.push(App.localize('TreatmentAndPrescriptionSummaryNarrative',
            treatmentCount, prescriptionCount));
        }
        message.push(vm.currencyCode + vm.totalTreatmentAmount);
      } else {
        message.push(App.localize('NoTreatmentAndPrescriptionSummaryNarrative'));
      }

      // Assign view model values.

      vm.uncoveredTreatmentLength = uncoveredTreatmentCount;
      vm.summaryMessage = message.join('. ');
    }

    function checkExclusionsForPrescription(treatment, prescription) {
      return (
        checkCorporateExclusion(prescription) ||
        checkTreatmentExclusion(treatment, prescription)
      );
    }

    function checkTreatmentExclusion(treatment, prescription) {
      const hasExclusion = _.some(prescription.treatmentExclusions,
        (t) => t === treatment.treatmentId);
      prescription.hasTreatmentExclusion = hasExclusion;
      return hasExclusion;
    }

    function checkCorporateExclusion(prescription) {
      const hasExclusion = _.some(prescription.corporateExclusions, (c) => c === vm.corporateId);
      prescription.hasCorporateExclusion = hasExclusion;
      return hasExclusion;
    }
  }
})();
